var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":_vm.effect,"placement":_vm.placement,"disabled":_vm.disabled,"open-delay":_vm.openDelay}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("content")],2),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }